import {PModuleType} from '@e/configs';

export enum DevicesType {
  Machine = 4, // Станок
  Node = 5, // Узел
  Other = 6, // Другое
}

export enum HeaterStatus {
  NotWorking, // не работает
  Working, // работает
  Working2, // работает
  Error, // ошибка
}

export type SensorTypeItem = {x: number; y: number; z: number; ts: number; uuid: string};

export type SensorType = {
  vel: SensorTypeItem;
  rms: SensorTypeItem;
  temp: {val: number; ts: number; uuid: string};
  taho: {val: number; ts: number; uuid: string};
  amp: {val: number; ts: number; uuid: string};
  heater: {val: HeaterStatus; ts: number; uuid: string};
  uuid: string;
};

export type SensorTypeTransform = {
  vel: {x: number; y: number; z: number; ts: number; uuid: string}[];
  rms: {x: number; y: number; z: number; ts: number; uuid: string}[];
  temp: {val: number; ts: number; uuid: string}[];
  taho: {val: number; ts: number; uuid: string}[];
  amp: {val: number; ts: number; uuid: string}[];
  heater: {val: HeaterStatus; ts: number; uuid: string}[];
};

export interface UpdateSensorDataWSInterface extends SensorType {
  uuid: string;
}

export interface UpdateDataTableInterface {
  [key: string]: UpdateSensorDataWSInterface;
}

type GuidsType = {
  guids: string[];
};

type ServiceSchemeType = {
  modules: GuidsType[];
  name: string;
};

export type MachineItemType = {
  alias: string;
  id: number;
  name: string;
  type: DevicesType;
  type_description: string;
  children: any[];
  row: number;
  span: number;
  sensors: SensorTypeTransform;
  guids: string[];
  guid: string | undefined;
  services_scheme: ServiceSchemeType[];
  heater: HeaterStatus;
  measurements: MeasurementsType[];
};

export interface NodesDataInterface {
  [key: string]: SensorTypeTransform;
}

export interface GuidDataType {
  [key: number]: string[];
}

export type measurementsItemType = {
  bottom_danger_boundary: number | null;
  bottom_error_boundary: number | null;
  bottom_warning_boundary: number | null;
  module_type_measurement_id: number | null;
  top_danger_boundary: number | null;
  top_error_boundary: number | null;
  top_warning_boundary: number | null;
};

export interface MeasurementsType {
  vel: measurementsItemType;
  rms: measurementsItemType;
  temp: measurementsItemType;
  taho: measurementsItemType;
  amp: measurementsItemType;
  heater: measurementsItemType;
}

export interface ModuleItemType {
  id: number;
  guid: string;
  type: PModuleType;
  nodes: {node_id: number}[];
  values: SensorType;
  measurements: MeasurementsType[];
}

export interface SensorDataInterface {
  [key: number]: SensorTypeTransform;
}

export type SensorMeasurementsType = {
  [key: string]: any;
};
